module.exports = __webpack_public_path__ + "static/media/MSME Infographic mobile 22-02-2024 C.44599f25.gif";